const BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? 'https://ojbr4cjpvh.execute-api.ap-northeast-1.amazonaws.com';

export interface GrammarPattern {
  pattern_id: string;
  language: string;
  level: string;
  category: string;
  pattern: string;
  romanization: string;
  function: string;
}

export interface CoverageMap {
  [language: string]: number;
}

export interface GrammarActionResult {
  ok: boolean;
  added?: number;
  filled?: number;
  novel?: number;
  remapped?: number;
  unfilled_remaining?: number;
  reviewed?: number;
  fixes?: number;
  total?: number;
  stored?: boolean;
  research_length?: number;
  preview?: string;
  steps?: string[];
  raw?: string;
  qa_log?: Array<{ pattern_id: string; field: string; original: string; fixed: string; note: string }>;
  message?: string;
  timestamp?: string;
  error?: string;
}

export async function fetchGrammarPatterns(language: string): Promise<GrammarPattern[]> {
  const res = await fetch(`${BASE_URL}/api/admin/grammar?language=${encodeURIComponent(language)}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json() as { items: GrammarPattern[] };
  return data.items ?? [];
}

export async function fetchGrammarCoverage(): Promise<CoverageMap> {
  const res = await fetch(`${BASE_URL}/api/admin/grammar/coverage`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json() as { coverage: CoverageMap };
  return data.coverage ?? {};
}

export async function improveGrammar(language: string): Promise<GrammarActionResult> {
  const res = await fetch(`${BASE_URL}/api/admin/grammar/${encodeURIComponent(language)}/improve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  });
  return await res.json() as GrammarActionResult;
}

export async function qaGrammar(language: string): Promise<GrammarActionResult> {
  const res = await fetch(`${BASE_URL}/api/admin/grammar/${encodeURIComponent(language)}/qa`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  });
  return await res.json() as GrammarActionResult;
}

export async function dedupGrammar(language: string): Promise<GrammarActionResult> {
  const res = await fetch(`${BASE_URL}/api/admin/grammar/${encodeURIComponent(language)}/dedup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  });
  return await res.json() as GrammarActionResult;
}

export async function researchGrammar(language: string): Promise<GrammarActionResult> {
  const res = await fetch(`${BASE_URL}/api/admin/grammar/${encodeURIComponent(language)}/research`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  });
  return await res.json() as GrammarActionResult;
}
